import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {cancelTokenSource, useAxios} from "../hooks/hooks";
import {
  message,
  Space,
  Button,
  Table,
  Skeleton,
  Drawer,
} from "antd";
import { PageHeader } from '@ant-design/pro-layout';
import ErrorPage from "../pages/ErrorPage";
import ForbiddenPage from "../pages/ForbiddenPage";
import FieldComponent from "./FieldComponent";
import ViewFormComponent from "./ViewFormComponent";
import EditFormComponent from "./EditFormComponent";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";

function ListFormComponent(props) {
  const axios = useAxios();
  const source = cancelTokenSource;
  const { t } = useTranslation();
  const [error, setError] = useState(null);
  const [forbidden, setForbidden] = useState(false);
  const [loaded, setLoaded] = useState(false);
  const [datasource, setDatasource] = useState([]);
  const [columns, setColumns] = useState([]);
  const [pageLoaded, setPageLoaded] = useState(true);
  const [requestingData, setRequestingData] = useState(false);
  const [pageSize] = useState(100);
  const [page, setPage] = useState(1);
  const [lastPage, setLastPage] = useState(false);
  const [total, setTotal] = useState(0);
  const [id, setId] = useState(null);
  const [primaryKey, setPrimaryKey] = useState(null);
  const [viewDrawer, setViewDrawer] = useState(false);
  const [editDrawer, setEditDrawer] = useState(false);
  const [deleteDrawer, setDeleteDrawer] = useState(false);

  const loadNextPage = () => {
    var next_page = page + 1;
    setPage(next_page);
  };

  const getData = async function (current_page, old_datasource, old_columns) {
    setRequestingData(true);
    if (isNaN(current_page) === false) {
      setPage(current_page);
    }
    var p = current_page || page;
    try {
      var params = {
        page_size: pageSize,
        page: p,
      };
      if (props.filter) {
        for (var f in props.filter) {
          params["filter[" + f + "]"] = props.filter[f];
        }
      }
      const response = await axios.current.get(props.endpoint.namespace.code, {
        params,
      });
      var result = response.data;
      if (result.error) {
        setError(JSON.stringify(result.error));
        return;
      }
      //PAGINATION
      setTotal(result.total_rows);
      /*
			var l = old_datasource.length;
			var diff = result.total_rows-l;
			for(var a =0;a<diff;a++){
				old_datasource.push({key:(l+a).toString()});
			}
*/
      if (result.rows.length === 0) {
        setRequestingData(false);
        setLastPage(true);
        return;
      }
      var col_len = old_columns.length;
      var len = result.rows.length;
      for (var e = 0; e < len; e++) {
        var index = (page - 1) * pageSize + e;
        result.rows[e].key = index;
        old_datasource.push(result.rows[e]);
        //old_datasource[index] = result.rows[e];
        for (var b = 0; b < col_len; b++) {
          var column = old_columns[b];
          if (undefined === column.filters) continue;
          if (column.filters === null) continue;
          var value = result.rows[e][column.key];
          var filtered = column.filters.filter((f) => f.value === value);
          if (filtered.length === 0) {
            old_columns[b].filters.push({
              text: "" + value,
              value,
            });
          }
        }
      }
      if (old_datasource.length === result.total_rows) {
        setLastPage(true);
      }
      setDatasource(old_datasource);
      //setColumns(old_columns);
    } catch (error) {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            setForbidden(true);
            break;
          default:
            setError(JSON.stringify(error));
        }
      }
    }
  };

  //EFFECTS
  useEffect(() => {
    setRequestingData(false);
  }, [datasource]);

  useEffect(() => {
    if (pageLoaded === false) return;
    if (loaded === false) return;
    if (page === 0) return;
    var d = JSON.parse(JSON.stringify(datasource));
    var c = JSON.parse(JSON.stringify(columns));
    getData(page, d, c);
  }, [page]);

  useEffect(() => {
    let page = 1;
    let datasource = [];
    var ee = JSON.parse(JSON.stringify(props.endpoint.entity));
    var pk = ee.is_meta === true ? "_id" : ee.mysql.primary;
    setPrimaryKey(pk);
    var columns = [
      {
        title: "#",
        dataIndex: pk,
        key: pk,
        sorter: (x, y) => {
          return x[pk] > y[pk];
        },
      },
    ];
    const attributes = JSON.parse(JSON.stringify(props.endpoint.attributes));
    delete attributes[pk];
    for (var a in attributes) {
      const fk =
        ee.is_meta === true
          ? null
          : props.endpoint.attributes[a].mysql.foreign_key;
      const field = fk ? props.endpoint.attributes[a].foreign_display_alias : a;
      const type = fk
        ? "foreign_key"
        : props.endpoint.attributes[a].fieldtype.name;
      const filters =
        ["number", "text", "foreign_key"].indexOf(type) === -1
          ? ["switch", "question", "logical"].indexOf(type) === -1
            ? null
            : [
                { text: "True", value: 1 },
                { text: "False", value: 0 },
              ]
          : [];
      const column = {
        title: t(attributes[a].name),
        dataIndex: field,
        key: field,
        render: (text, record, index) => (
          <>
            <FieldComponent value={text} view={true} fieldtype={type} />
          </>
        ),
        sorter: (x, y) => {
          if (typeof x[field] === "string" && typeof y[field] === "string") {
            return x[field].localeCompare(y[field], undefined, {
              numeric: true,
              sensitivity: "base",
            });
          }
          if (typeof x[field] === "number" && typeof y[field] === "number") {
            return x[field] > y[field];
          }
          return false;
        },
      };
      if (filters != null) {
        column.filters = filters;
        column.filterMultiple = true;
        column.onFilter = (value, record) => {
          if (record[field] === value) return true;
          if (undefined === record[field]) return false;
          if (record[field] === null) return false;
          if (isNaN(value) === false) {
            return value === record[field];
          }
          if (record[field].toLowerCase().indexOf(value) === -1) return false;
          return true;
        };
      }
      columns.push(column);
    }
    columns.push({
      title: t("Actions"),
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => {
        if (props.endpoints) {
          return (
            <Space>
              <Button
                type="primary"
                onClick={() => {
                  setId(record[pk]);
                  setViewDrawer(true);
                }}
              >
                <FontAwesomeIcon icon="eye" />
              </Button>
              <Button
                type="secondary"
                onClick={() => {
                  setId(record[pk]);
                  setEditDrawer(true);
                }}
              >
                <FontAwesomeIcon icon="pencil-alt" />
              </Button>
              <Button
                type="danger"
                onClick={() => {
                  setId(record[pk]);
                  setDeleteDrawer(true);
                }}
              >
                <FontAwesomeIcon icon="trash" />
              </Button>
            </Space>
          );
        }
        // Project-scoped lists: staff lists are backed by the `project` table
        // (pk id_project); the customer "client" list is backed by the
        // `view_project` view (pk id_view_project, which is the project id).
        // Neither exposes a column literally named id_project, so key the
        // Clearance Report button off the backing table instead.
        const table = ee.is_meta === true ? null : ee.mysql.table;
        const idProject =
          (table === "project" || table === "view_project") &&
          record[pk] !== undefined &&
          record[pk] !== null
            ? record[pk]
            : null;
        return (
          <Space>
            <Button type="primary">
              <Link
                to={
                  props.home +
                  props.endpoint.namespace.code +
                  "/view/" +
                  record[pk]
                }
              >
                <FontAwesomeIcon icon="eye" />
                &nbsp;{t("View")}
              </Link>
            </Button>
            {idProject !== null && (
              <Button>
                <Link to={props.home + "docs/clearance-report/" + idProject}>
                  <FontAwesomeIcon icon="clipboard-check" />
                  &nbsp;{t("CLR Reports")}
                </Link>
              </Button>
            )}
          </Space>
        );
      },
    });
    setColumns(columns);
    setLoaded(true);
    getData(page, datasource, columns).then(()=>{
      console.log("got data")
    });
  }, [props]);

  useEffect(() => {

    return () => {
      source.cancel();
    };
  }, []);

  // useEffect(() => {
  //   console.log("List Form Component")
  //   console.log(props)
  // }, [props])
  // useEffect(() => {
  //   console.log("List Form Component loading: "+ loaded)
  // }, [loaded])

  //RENDER
  if (!loaded) {
    return <Skeleton active />;
  }
  if (loaded && error) {
    return <ErrorPage error={error} />;
  }
  if (loaded && forbidden) {
    return <ForbiddenPage />;
  }
  if (loaded && !error) {
    return (
      <>
        <PageHeader
          style={{ padding: "0px 0px 16px 0px" }}
          title={t(props.endpoint.namespace.name)}
          extra={
            props.create === true
              ? [
                  <Button key="1" block>
                    <Link
                      to={props.home + props.endpoint.namespace.code + "/new"}
                    >
                      <FontAwesomeIcon icon="plus" />
                      &nbsp;
                      {t("New Entity", {
                        entity: props.endpoint.namespace.name,
                      })}
                    </Link>
                  </Button>,
                ]
              : []
          }
        />
        {!pageLoaded && <Skeleton active />}
        {pageLoaded && (
          <>
            <Table
              scroll={{ x: "100%" }}
              columns={columns}
              dataSource={datasource}
              pagination={false}
              locale={{
                filterTitle: t("Filter menu"),
                filterConfirm: t("OK"),
                filterReset: t("Reset"),
                filterEmptyText: t("No filters"),
                selectAll: t("Select current page"),
                selectInvert: t("Invert current page"),
                selectionAll: t("Select all data"),
                sortTitle: t("Sort"),
                expand: t("Expand row"),
                collapse: t("Collapse row"),
                triggerDesc: t("Click sort by descend"),
                triggerAsc: t("Click sort by ascend"),
                cancelSort: t("Click to cancel sort"),
              }}
              /*
				  	  pagination={{
								current:page,
								total:datasource.length,
								pageSize:pageSize,
								onChange:setPage,
								showSizeChanger:false
							}}
*/
            />
            <Button
              style={{ width: "100%" }}
              onClick={loadNextPage}
              type="primary"
              disabled={requestingData === true || lastPage === true}
            >
              {lastPage === true
                ? t("No more rows")
                : requestingData === true
                ? t("Requesting Data")
                : t("More")}
            </Button>
          </>
        )}
        <Drawer
          title={t("View Record")}
          open={viewDrawer}
          onClose={() => setViewDrawer(false)}
          currentproject={props.currentproject}
          placement="left"
          width="75%"
        >
          {id && props.endpoint && (
            <ViewFormComponent
              home="/dashboard/"
              endpoint={props.endpoints[props.endpoint.namespace.code].view}
              history={props.history}
              remove={false}
              id={id}
              update={false}
              back={false}
            />
          )}
        </Drawer>
        <Drawer
          title={t("Edit Record")}
          open={editDrawer}
          onClose={() => setEditDrawer(false)}
          placement="left"
          width="75%"
        >
          {id && props.endpoints && (
            <EditFormComponent
              home="/dashboard/"
              endpoint={props.endpoints[props.endpoint.namespace.code].update}
              history={props.history}
              remove={false}
              id={id}
              currentproject={props.currentproject}
              back={false}
              onUpdate={(i, v, s) => {
                if (s === false) {
                  setEditDrawer(false);
                  setId(null);
                  return;
                }
                var d = JSON.parse(JSON.stringify(datasource));
                var l = d.length;
                for (var a = 0; a < l; a++) {
                  var r = d[a];
                  if (r[primaryKey] === i) {
                    for (var k in v) {
                      d[a][k] = v[k];
                    }
                    break;
                  }
                }
                setDatasource(d);
                setEditDrawer(false);
                setId(null);
              }}
            />
          )}
        </Drawer>
        <Drawer
          title={t("Delete Record")}
          open={deleteDrawer}
          onClose={() => setDeleteDrawer(false)}
          placement="left"
          width="75%"
        >
          {id && props.endpoints && (
            <ViewFormComponent
              home="/dashboard/"
              endpoint={props.endpoints[props.endpoint.namespace.code].remove}
              history={props.history}
              remove={true}
              id={id}
              update={true}
              back={false}
              onDelete={(i, s) => {
                if (s === false) {
                  setDeleteDrawer(false);
                  setId(null);
                  message.error(t("Could not delete the record."));
                  return;
                }
                var d = JSON.parse(JSON.stringify(datasource));
                var l = d.length;
                var index = null;
                for (var a = 0; a < l; a++) {
                  var r = d[a];
                  if (r[primaryKey] === i) {
                    index = a;
                    break;
                  }
                }
                d.splice(index, 1);
                setDatasource(d);
                setDeleteDrawer(false);
                setId(null);
                message.success(t("Record deleted successfully."));
              }}
            />
          )}
        </Drawer>
      </>
    );
  }
}

export default ListFormComponent;
